import React from "react";
import Header from "../../../Shared/Header";

const Settings = () => {
  return (
    <div className="">
      <Header />
    </div>
  );
};

export default Settings;
